












import { Component, Watch, Prop, ProvideReactive, Vue } from 'vue-property-decorator'

// Models
import NaviModel from '@/_models/NaviModel'

// Components
import DripNaviLayout from './partials/DripNaviLayout.vue'
import DripNaviMobileLayout from './partials/DripNaviMobileLayout.vue'

@Component({
  components: { DripNaviLayout, DripNaviMobileLayout },
})
export default class DripNaviPane extends Vue {
  @Prop()
  @ProvideReactive('navi-data')
  naviItems!: NaviModel[]

  @Prop()
  @ProvideReactive('navi-blink')
  isBlinkRefresh!: boolean

  @Prop()
  @ProvideReactive('navi-height')
  height!: number

  isShowDripnaviPane: boolean = false
  isCollapse: boolean = false

  get naviPaneStyle() {
    if (this.height > 0) {
      return {
        height: `${this.height}px`,
      }
    }

    return {
      maxHeight: '75vh',
    }
  }

  @Watch('naviItems')
  userChanged() {
    const hasDripPane = this.naviItems.length
    // Dont close pane
    if (hasDripPane) {
      this.isShowDripnaviPane = true
    }
  }

  setCollapseState(state) {
    this.isCollapse = state
  }
}
